import * as React from "react";
import { Col } from "./../Col";
import * as CMP from "../../../../components";
export class Silk extends React.Component {
    render() {
        return (React.createElement(Col, { modifier: "rj-racing-next-races__col--silk" },
            React.createElement(CMP.Silk, { src: this.props.src })));
    }
}
//# sourceMappingURL=Silk.js.map